import { MediaQuery } from '@grandvisionhq/common';
import { useStoreFinderContext } from '../context/StoreFinder/context.js';
import '@swc/helpers';
import 'react';
import '@grandvisionhq/locations';
import '@grandvisionhq/utils';
import 'lodash/deburr';
import '../context/StoreFinderSlots/context.js';

const useTabs = ()=>{
    const { isPristineSearch  } = useStoreFinderContext();
    const isMobile = MediaQuery.useIsPhone();
    return isMobile && !isPristineSearch;
};

export { useTabs };
//# sourceMappingURL=use-tabs.js.map
